import React, { useState } from 'react';
import './Tienda.css';
import ProductoDetalle from './ProductoDetalle';
import { useCart } from '../context/CartContext';

const Tienda = () => {
  const [filtroDonJacinto, setFiltroDonJacinto] = useState('todos');
  const [filtroMelva] = useState('todos');
  const [filtroHiloRojo] = useState('todos');
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const { addToCart } = useCart();

  // Productos destacados
  const seleccionados = [
    {
      id: 1,
      nombre: 'Blend',
      linea: 'Don Jacinto Select Blend',
      descripcion: 'Blend exclusivo de nuestras mejores cepas. Equilibrio perfecto entre cuerpo y elegancia.',
      variedad: 'Vino Tinto Premium',
      precio: 1300,
      imagen: require('../assets/blend.jpg')
    },
    {
      id: 2,
      nombre: 'Melva',
      linea: 'Melva',
      descripcion: 'Tannat de alta gama con 18 meses en barrica. Nuestro vino más premiado.',
      variedad: 'Vino Tinto Reserva',
      precio: 549,
      imagen: require('../assets/melva.jpg')
    }
  ];

  // Productos Don Jacinto
  const productosDonJacinto = [
    {
      id: 3,
      nombre: 'Chardonnay',
      linea: 'Cosecha',
      variedad: 'Vino Blanco',
      precio: 329,
      imagen: require('../assets/chardonnay.jpg')
    },
    {
      id: 4,
      nombre: 'Tannat',
      linea: 'Gran Reserva',
      variedad: 'Vino Tinto',
      precio: 459,
      imagen: require('../assets/tannat.jpg')
    },
    {
      id: 8,
      nombre: 'Cabernet Sauvignon',
      linea: 'Gran Reserva',
      variedad: 'Vino Tinto',
      precio: 459,
      imagen: require('../assets/cab-s.jpg')
    },
    {
      id: 1,
      nombre: 'Blend',
      linea: 'Blend de Añadas',
      descripcion: 'Blend exclusivo de nuestras mejores cepas. Equilibrio perfecto entre cuerpo y elegancia.',
      variedad: 'Vino Tinto Premium',
      precio: 1360,
      imagen: require('../assets/blend.jpg')
    },
    {
      id: 5,
      nombre: 'Merlot',
      linea: 'Gran Reserva',
      variedad: 'Vino Tinto',
      precio: 459,
      imagen: require('../assets/merlot.jpg')
    },
    {
      id: 6,
      nombre: 'Torrontés',
      linea: 'Cosecha',
      variedad: 'Vino Blanco',
      precio: 329,
      imagen: require('../assets/torrontes.jpg')
    },
    {
      id: 7,
      nombre: 'Blend Rosé',
      linea: 'Cosecha',
      variedad: 'Vino Rosado',
      precio: 329,
      imagen: require('../assets/blend-rose.jpg')
    }
  ];

  // Productos Melva
  const productosMelva = [
    {
      id: 11,
      nombre: 'Melva',
      linea: 'Melva',
      variedad: 'Espumoso Natural',
      precio: 549,
      imagen: require('../assets/melva.jpg')
    }
  ];

  // Productos Hilo Rojo
  const productosHiloRojo = [
    {
      id: 9,
      nombre: 'Blend',
      linea: 'Hilo Rojo',
      variedad: '',
      precio: 299,
      imagen: require('../assets/hilo-rojo2.jpg')
    },
    {
      id: 13,
      nombre: 'Cabernet Sauvignon',
      linea: 'Hilo Rojo',
      variedad: '',
      precio: 299,
      imagen: require('../assets/hilorojo-et-negra.jpg')
    }
  ];

  const donJacintoFiltrados = filtroDonJacinto === 'todos' 
    ? productosDonJacinto 
    : productosDonJacinto.filter(p => p.linea === filtroDonJacinto);

  const melvaFiltrados = filtroMelva === 'todos' 
    ? productosMelva 
    : productosMelva.filter(p => p.linea === filtroMelva);

  const hiloRojoFiltrados = filtroHiloRojo === 'todos' 
    ? productosHiloRojo 
    : productosHiloRojo.filter(p => p.linea === filtroHiloRojo);

  // Función para abrir detalle
  const abrirDetalle = (producto) => {
    setProductoSeleccionado(producto);
  };

  // Función para cerrar detalle
  const cerrarDetalle = () => {
    setProductoSeleccionado(null);
  };

  // Obtener productos relacionados (misma línea, excluyendo el actual)
  const obtenerRelacionados = (producto) => {
    const todosProductos = [...productosDonJacinto, ...productosMelva, ...productosHiloRojo];
    return todosProductos
      .filter(p => p.linea === producto.linea && p.id !== producto.id)
      .slice(0, 4);
  };

  return (
    <>
      {productoSeleccionado && (
        <ProductoDetalle 
          producto={productoSeleccionado}
          onClose={cerrarDetalle}
          productosRelacionados={obtenerRelacionados(productoSeleccionado)}
        />
      )}
      
      <section className="tienda-section" id="tienda">
      
      {/* Hero Vinos Seleccionados */}
      <div className="seleccionados-hero">
        <div className="seleccionados-hero-overlay"></div>
        <div className="seleccionados-hero-content">
          <div className="badge-outline">SELECCIÓN ESPECIAL</div>
          <h2 className="seleccionados-hero-title">VINOS SELECCIONADOS</h2>
          <p className="seleccionados-hero-subtitle">Nuestras etiquetas más premiadas</p>
        </div>
      </div>

      {/* Productos Destacados */}
      <div className="container">
        <div className="destacados-wrapper">
          {seleccionados.map(producto => (
            <div key={producto.id} className="destacado-item">
              <div className="destacado-imagen-wrapper" onClick={() => abrirDetalle(producto)}>
                <div className="destacado-badge">{producto.linea}</div>
                <img src={producto.imagen} alt={producto.nombre} className="destacado-imagen" />
              </div>
              <div className="destacado-info">
                <h3 className="destacado-nombre" onClick={() => abrirDetalle(producto)}>{producto.nombre}</h3>
                <p className="destacado-descripcion">{producto.descripcion}</p>
                <div className="destacado-bottom">
                  <span className="destacado-precio">${producto.precio}</span>
                  <button className="btn-destacado" onClick={() => abrirDetalle(producto)}>VER DETALLE</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Separador */}
        <div className="tienda-divider"></div>

        {/* SECCIÓN DON JACINTO */}
        <div className="categoria-section">
          <div className="categoria-header">
            <h2 className="categoria-titulo">DON JACINTO</h2>
            <div className="categoria-linea"></div>
          </div>

          <div className="filtros-categoria">
            <button 
              className={`filtro-categoria-btn ${filtroDonJacinto === 'todos' ? 'active' : ''}`}
              onClick={() => setFiltroDonJacinto('todos')}
            >
              <span className="filtro-numero">{productosDonJacinto.length}</span>
              <span className="filtro-texto">TODOS</span>
            </button>
            <button 
              className={`filtro-categoria-btn ${filtroDonJacinto === 'Blend de Añadas' ? 'active' : ''}`}
              onClick={() => setFiltroDonJacinto('Blend de Añadas')}
            >
              <span className="filtro-numero">{productosDonJacinto.filter(p => p.linea === 'Blend de Añadas').length}</span>
              <span className="filtro-texto">BLEND DE AÑADAS</span>
            </button>
            <button 
              className={`filtro-categoria-btn ${filtroDonJacinto === 'Cosecha' ? 'active' : ''}`}
              onClick={() => setFiltroDonJacinto('Cosecha')}
            >
              <span className="filtro-numero">{productosDonJacinto.filter(p => p.linea === 'Cosecha').length}</span>
              <span className="filtro-texto">COSECHA</span>
            </button>
            <button 
              className={`filtro-categoria-btn ${filtroDonJacinto === 'Gran Reserva' ? 'active' : ''}`}
              onClick={() => setFiltroDonJacinto('Gran Reserva')}
            >
              <span className="filtro-numero">{productosDonJacinto.filter(p => p.linea === 'Gran Reserva').length}</span>
              <span className="filtro-texto">GRAN RESERVA</span>
            </button>
          </div>

          <div className="productos-grid">
            {donJacintoFiltrados.map(producto => (
              <div key={producto.id} className="producto-card">
                <div className="producto-imagen" onClick={() => abrirDetalle(producto)}>
                  <img src={producto.imagen} alt={producto.nombre} />
                  <div className="producto-overlay">
                    <button className="btn-ver-detalle">VER DETALLE</button>
                  </div>
                </div>
                <div className="producto-info">
                  <span className="producto-linea">{producto.linea}</span>
                  <h3 className="producto-nombre" onClick={() => abrirDetalle(producto)}>{producto.nombre}</h3>
                  <p className="producto-variedad">{producto.variedad}</p>
                  <div className="producto-footer">
                    <span className="producto-precio">${producto.precio}</span>
                    <button className="btn-agregar" onClick={() => addToCart(producto)}>
                      <span>+</span> AGREGAR
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* SECCIÓN MELVA */}
        <div className="categoria-section">
          <div className="categoria-header">
            <h2 className="categoria-titulo">MELVA</h2>
            <div className="categoria-linea"></div>
          </div>

          <div className="productos-grid">
            {melvaFiltrados.map(producto => (
              <div key={producto.id} className="producto-card">
                <div className="producto-imagen" onClick={() => abrirDetalle(producto)}>
                  <img src={producto.imagen} alt={producto.nombre} />
                  <div className="producto-overlay">
                    <button className="btn-ver-detalle">VER DETALLE</button>
                  </div>
                </div>
                <div className="producto-info">
                  <span className="producto-linea">{producto.linea}</span>
                  <h3 className="producto-nombre" onClick={() => abrirDetalle(producto)}>{producto.nombre}</h3>
                  <p className="producto-variedad">{producto.variedad}</p>
                  <div className="producto-footer">
                    <span className="producto-precio">${producto.precio}</span>
                    <button className="btn-agregar" onClick={() => addToCart(producto)}>
                      <span>+</span> AGREGAR
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* SECCIÓN HILO ROJO */}
        <div className="categoria-section">
          <div className="categoria-header">
            <h2 className="categoria-titulo">HILO ROJO</h2>
            <div className="categoria-linea"></div>
          </div>

          <div className="productos-grid">
            {hiloRojoFiltrados.map(producto => (
              <div key={producto.id} className="producto-card">
                <div className="producto-imagen" onClick={() => abrirDetalle(producto)}>
                  <img src={producto.imagen} alt={producto.nombre} />
                  <div className="producto-overlay">
                    <button className="btn-ver-detalle">VER DETALLE</button>
                  </div>
                </div>
                <div className="producto-info">
                  <span className="producto-linea">{producto.linea}</span>
                  <h3 className="producto-nombre" onClick={() => abrirDetalle(producto)}>{producto.nombre}</h3>
                  <p className="producto-variedad">{producto.variedad}</p>
                  <div className="producto-footer">
                    <span className="producto-precio">${producto.precio}</span>
                    <button className="btn-agregar" onClick={() => addToCart(producto)}>
                      <span>+</span> AGREGAR
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
      </section>
    </>
  );
};

export default Tienda;
